<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

        <div class="np-base-dialog modal-dialog modal-lg modal-dialog-centered w-100" :class="modalClass">
            <div class="modal-content shadow">
                <div class="modal-header border-0 p-4 pb-2">
                    <span class="col-sm-8 d-flex align-middle">
                        <div class="d-dlex">{{ $t("UI.task.inviteTitle") }}</div>
                    </span>
                    <div class="d-flex justify-content-end flex-grow-1">
                        <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                            <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                        </button>
                    </div>
                </div>

                <div class="modal-body ps-3 pe-3">
                    <div class="row m-0 w-100 h-100">
                        <div class="col">
                            <p class="mb-4">{{ $t("UI.task.inviteDescription") }}</p>
                            <div class="mb-4">
                                <label class="typo__label">{{ $t("UI.task.inviteRole") }}</label>
                                <div class="d-flex">
                                    <multiselect 
                                        v-model="this.selectedRole" 
                                        :options="this.availableRoles" 
                                        :searchable="false" 
                                        :close-on-select="true" 
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="title"
                                        class="cobalt-select-simple me-2">
                                    </multiselect>
                                    <button type="button" class="btn nav-link-bg cobalt-blue-button btn-sm np-nowrap m-0" @click="receiveInviteCode">
                                        {{ $t("UI.task.requestInviteCode") }}
                                    </button>
                                </div>
                            </div>                
                            <div class="mb-4" v-if="this.inviteLink">
                                <label for="inviteLinkInput">{{ $t("UI.task.inviteLink") }}</label>
                                <a ref="inviteLinkRef" class="form-control cobalt-copy-button" id="inviteLinkInput" aria-describedby="inviteLinkHelp" @click="copy">
                                    {{ this.inviteLink }}
                                </a>
                                <small id="inviteLinkHelp" class="form-text text-muted"></small>
                            </div> 
                        </div>
                    </div>                               
                </div>
                <div class="modal-footer p-3">
                    <button type="button" class="np-btn np-danger px-4"
                        data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                </div>                   
            </div>
        </div>
    </div>
</template>

<script>
import { useDashboardStore } from "@/stores/dashboardStore"
import { Modal } from "bootstrap"
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import { createToast } from 'mosha-vue-toastify' 

export default {
    components: {
        Multiselect
    },
    props: {
        modalID: {
            type: String,
            required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        }          
    }, 
    data() {
        return {  
            currentId: null,
            currentType: null,
            availableRoles: [],
            selectedRole: null,  
            inviteLink: '',          
            theModal: null,
            theModalLabel: null,
            isLoading: false
        }
    },    
    computed: {   
        dashboardStore() {
            return useDashboardStore()
        },
        currentRoute: {
            get() {     
                const hostName = window.location.origin
                return hostName
            }
        }                
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})
    },           
    methods: {
        ...mapActions('company', ['inviteCode', 'sendInvitation']),
        ...mapActions('project', {getProjectInviteCode: 'inviteCode'}),        
        ...mapActions('roles', ['listRoles']),
        ...mapGetters('roles', ['getListRoles']),

        async shows(type, id) { // 0 - space, 1 - project
            this.currentId = id
            this.currentType = type

            let param = {}
            if (type === 0) {
                param = { "company_id": id }
            } else {
                param = { "project_id": id }
            }

            await this.listRoles(param)

            this.availableRoles = this.getListRoles()
            this.inviteLink = ''

            if (this.availableRoles.length > 0) {
                this.selectedRole = this.availableRoles[0]
            }

            this.theModal.show()
        },
        hide() {
            this.theModal.hide()
        },
        async close() {
            this.$emit('closeModal')
        },
        async receiveInviteCode() {
            const data = {
                'id': 0,
                'role': 1 // Пока отправляем роль 1, по-умолчанию 
            }
            let res = ''

            data.role = this.selectedRole.id

            if (this.currentType === 0) {
                data.id = this.currentId
                res = await this.inviteCode(data)
            } else {
                data.id = this.currentId
                res = await this.getProjectInviteCode(data)
            }
            
            if (res) {
                this.inviteLink = this.currentRoute + '/invite?code=' + res.code
            }
        }, 
        async sendInviteEmail() {

            if (!this.inviteEmail) return

            const data = {
                    'id': this.project.company_id,
                    'role': 1, // Пока отправляем роль 1, по-умолчанию 
                    'email': this.inviteEmail,
                    'code': this.inviteObject.code
                }
            
            let res = await this.sendInvitation(data)

            createToast({ description: this.$t("UI.inviteSend") }, {
                    hideProgressBar: true,
                    timeout: 1000,
                    position: 'bottom-center',
                    transition: 'slide',
                    showIcon: false,
                    showCloseButton: false,
                    swipeClose: false,
                })
            
            this.close()  
        },
        async copy(event) {
            try {
                await navigator.clipboard.writeText(event.target.textContent);
                
                createToast({ description: this.$t("UI.linkCopied") }, {
                    hideProgressBar: true,
                    timeout: 1000,
                    position: 'bottom-center',
                    transition: 'slide',
                    showIcon: false,
                    showCloseButton: false,
                    swipeClose: false,
                })
            } catch($e) {
                alert('Cannot copy')
            }
        }               
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>